$(document).ready(function(){
/********** feature hover tooltip dekstop ******************/
    $('.featured_content_desktop').hover(function(){
      $(this).toggleClass('acive');
    });

  /********** feature hover tooltip mobile ******************/
    $('.mobile_view').click(function(){
      $(this).toggleClass('acive');
   });

  

  $('.common_features_section .hover_section_main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.icons-with-slider.homepage-icons.custom_all_icon-blog-wrapp .grid.grid--uniform',
    dots: false,
    infinite: false,
    arrows:false,
    centerMode: false,
    focusOnSelect: true
  });
  $('.icons-with-slider.homepage-icons.custom_all_icon-blog-wrapp .grid.grid--uniform').slick({
    infinite: false,
    slidesToShow: 6, // Shows a three slides at a time
    slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
    focusOnSelect: true,
    arrows:false,
    asNavFor: '.common_features_section .hover_section_main',
    dots: false
  });

/****************** Cookie functions start ****************************/
   function setCookie(name,value,period='') {
  var cookieValue = '';
  var expire = '';
  
  //Specify the cookie name and value
  cookieValue = name + '=' + JSON.stringify(value) + ';';

  //Specify the path to set the cookie
  cookieValue += 'path=/ ;';

  //Specify how long you want to keep cookie
 // period = 30; //days to store
  expire = new Date();
  expire.setTime(expire.getTime() + 1000 * 3600 * 24 * period);
  expire.toUTCString();
  cookieValue += 'expires=' + expire + ';';

  //Set cookie
  document.cookie = cookieValue;
  
}
function getCookie(c_name) {
  if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";

}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
/****************** Cookie functions end ****************************/

/******************* How to choose compare one start ************************/
    $('.block-selectors').each(function() {
      var $this = $(this);
        var id = $(this).attr('id');
        var storedIndex = getCookie("block-" + id + "-jtpl");
      storedIndex = storedIndex.replaceAll('"','');
      if(storedIndex){
        console.log(storedIndex + "===id==="+id);
        setTimeout(function(){
           $this.find(".block-head-jtpl li[data-index='" + storedIndex + "']").trigger("click");
          
        },1000);
          
      }
      });
   $('body').on('click', '.checkout__button', function() {
    $('.block-selectors').each(function() {
        var id = $(this).attr('id');
        eraseCookie("block-" + id + "-jtpl");
      eraseCookie("main-block-" + id + "-jtpl");
    });
});
    $('.block-selectors').each(function() {
      var $this = $(this);
        var id = $(this).attr('id');
        var storedIndex = getCookie("block-" + id + "-jtpl");
      storedIndex = storedIndex.replaceAll('"','');
      if(storedIndex){
        console.log(storedIndex + "===id==="+id);
        setTimeout(function(){
           $this.find(".block-head-jtpl li[data-index='" + storedIndex + "']").trigger("click");
          
        },1000);
          
      }
      });
  
  $('section').click(function(e) {
    if(!$('.block-head-jtpl li').is(e.target)){
       $('.block-head-jtpl').css('display','none');
       $('.block-head-jtpl').removeClass('display','highlighted');
      }
    }); 
 
    
  
   $('body').on('click', '.block-head-jtpl li', function(e) {
    e.preventDefault();
    // var vall = $(this).attr("data-index"); 
    // var id = $(this).parents(".block-selectors").attr("id"); 
    // console.log(vall + "======"+ id); 
    // console.log(".block-selectors#" + id);
    // $(".main-block-selectors#" + id + " .main-block-head-jtpl li[data-index-jtpl='" + vall + "']").trigger("click");
     var vall = $(this).data("index"); 
       $(this).closest('.block-head-jtpl').hide();
     var id = $(this).closest(".block-selectors").attr("id"); 
     if (e.target.hasTriggered) return;
     e.target.hasTriggered = true;
     console.log(vall + "======"+ id);
  
      setCookie("block-"+id+"-jtpl",vall,10);
      
    $(".main-block-selectors#" + id + " .main-block-head-jtpl li[data-index-jtpl='" + vall + "']").trigger("click");
    setTimeout(() => e.target.hasTriggered = false, 100);
     $('.main-block-head-jtpl').hide();
   
    
    var $this = $(this);
    $(this).parents(".block-head-jtpl").find("li").removeClass("active");
    $(this).addClass("active"); 
    $(this).parents(".block-head-jtpl").removeClass("highlighted");
    var html = $this.html();
    var id = $this.parents(".block-selectors").attr("id");
    $("#" + id + " .main-block-list").html(html);
    $("#" + id + " .main-block-list").addClass("added-jtpl").css("background","#f0f0f0");
    var handle = $this.attr("data-index");
    var content = $(".mobile_table_heading_wrapper[tab-title='" + handle + "']").html();
    $(".block-selectors#" + id + " .block-body-jtpl").html(content);
    var $blockHeadJtpl = $(this).parents(".block-selectors").find(".block-head-jtpl");
    if ($blockHeadJtpl.is(":visible")) {
        $blockHeadJtpl.hide();
      $('.block-head-jtpl').hide();
    } else {
        $blockHeadJtpl.show();
      $('.block-head-jtpl').hide();
    }
    var main_id = $this.parents(".block-head-jtpl").attr("id");
    // $(".block-head-jtpl li").removeClass("hidden");
    $(".block-head-jtpl").each(function() {
        var block_id = $(this).attr("id");
        if (block_id != main_id) {
            // $(this).find("li[data-index='" + handle + "']").addClass("hidden");
        }
    });

});
$('body').on('click', '.main-block-list', function(e) {
    // Find the corresponding .block-head-jtpl to toggle
    var $blockHeadJtpl = $(this).closest(".block-selectors").find(".block-head-jtpl");

    // If the clicked element is already highlighted, remove the class and hide it
    if ($blockHeadJtpl.hasClass('highlighted')) {
        $blockHeadJtpl.removeClass('highlighted').css('display', 'none');
    } else {
        // Otherwise, remove 'highlighted' class from all .block-head-jtpl elements
        $('.block-head-jtpl').removeClass('highlighted').css('display', 'none'); // Hide all other lists

        // Add the 'highlighted' class to the clicked .block-head-jtpl
        $blockHeadJtpl.addClass('highlighted').css('display', 'block'); // Show the clicked list
    }
});


// $('body').on('click', '.main-block-list', function(e) {
//     e.preventDefault();
//     var $blockHeadJtpl = $(this).parents(".block-selectors").find(".block-head-jtpl");
//     if ($blockHeadJtpl.is(":visible")) {
//         $blockHeadJtpl.hide();
//     } else {
//         $blockHeadJtpl.show();
//     }
// });
$('body').on('click', '.mobile_table_heading_wrapper .table-li-jtpl', function() {
    var $tableHeadJtpl = $(this).parents(".mobile_table_heading_wrapper").find(".table-head-jtpl");
    if ($tableHeadJtpl.is(":visible")) {
        $tableHeadJtpl.hide();
    } else {
        $tableHeadJtpl.show();
    }
});
$('body').on('click', '.heading-inner-table', function() {
    var dataTarget = $(this).attr("data-index");
    console.log("dataTarget" + dataTarget);
    var mydata = $("#" + dataTarget).siblings();
    console.log(mydata);
    $(this).parents("ul.mobile_table_heading_wrapper").html(mydata);
});
/******************* How to choose compare one end ************************/

/******************* How to choose compare two start ************************/
$('section').click(function(e) {
    if(!$('.main-block-head-jtpl li').is(e.target)){
      $('.main-block-head-jtpl').css('display','none');
      }
    });
  
  $('body').on('click', '.main-block-head-jtpl li', function(e) {
    e.preventDefault();
    
    // var val = $(this).attr("data-index-jtpl"); 
    // var id= $(this).parents(".main-block-selectors").attr("id"); 
    // console.log(val+"======"+id); 
    //   console.log(".block-selectors#"+id);
    // $(".block-selectors#"+id+" .block-head-jtpl li[data-index='"+val+"']").trigger("click"); 

    var val = $(this).data("index-jtpl"); 
    $(this).closest('.main-block-head-jtpl').hide();
    var id = $(this).closest(".main-block-selectors").attr("id"); 
    if (e.target.hasTriggered) return;
    e.target.hasTriggered = true;
    console.log(val + "======"+ id); 
      
      setCookie("main-block-"+id+"-jtpl",val,10);
    $(".block-selectors#" + id + " .block-head-jtpl li[data-index='" + val + "']").trigger("click");
    setTimeout(() => e.target.hasTriggered = false, 100);
       $('.block-head-jtpl').hide();
    var $this = $(this);
    $(this).parents(".main-block-head-jtpl").find("li").removeClass("active");
    $(this).addClass("active"); 
     $(this).parents(".main-block-head-jtpl").removeClass("highlighted");     
    var html = $this.html();
    var id = $this.parents(".main-block-selectors").attr("id");
    $("#" + id + " .main-block-list-jtpl").html(html);
    $("#" + id + " .main-block-list-jtpl").addClass("added-jtpl").css("background","#f0f0f0");
    var handle = $this.attr("data-index-jtpl");
    var content = $(".mobile_table_heading_wrapper-jtpl[tab-title-jtpl='" + handle + "']").html();
    $(".main-block-selectors#" + id + " .block-body-jtpl").html(content);
    var $mainBlockHeadJtpl = $(this).parents(".main-block-selectors").find(".main-block-head-jtpl");
    if ($mainBlockHeadJtpl.is(":visible")) {
        $mainBlockHeadJtpl.hide();
      $('.main-block-head-jtpl').hide();
    } else {
        $mainBlockHeadJtpl.show();
      $('.main-block-head-jtpl').hide();
    }
    
    var main_id = $this.parents(".main-block-head-jtpl").attr("id");
   // $(".main-block-head-jtpl li").removeClass("hidden");
    $(".main-block-head-jtpl").each(function() {
        var block_id = $(this).attr("id");
        if (block_id != main_id) {
          //  $(this).find("li[data-index-jtpl='" + handle + "']").addClass("hidden");
        }
    });
});
// $('body').on('click', '.main-block-list-jtpl', function(e) {
//     e.preventDefault();
//     var $mainBlockHeadJtpl = $(this).parents(".main-block-selectors").find(".main-block-head-jtpl");
//     if ($mainBlockHeadJtpl.is(":visible")) {
//         $mainBlockHeadJtpl.hide();
//     } else {
//         $mainBlockHeadJtpl.show();
//     }
// });
$('body').on('click', '.main-block-list-jtpl', function(e) {
    // Find the corresponding .block-head-jtpl to toggle
    var $blockHeadJtpl = $(this).closest(".main-block-selectors").find(".main-block-head-jtpl");

    // If the clicked element is already highlighted, remove the class and hide it
    if ($blockHeadJtpl.hasClass('highlighted')) {
        $blockHeadJtpl.removeClass('highlighted').css('display', 'none');
    } else {
        // Otherwise, remove 'highlighted' class from all .block-head-jtpl elements
        $('.main-block-head-jtpl').removeClass('highlighted').css('display', 'none'); // Hide all other lists

        // Add the 'highlighted' class to the clicked .block-head-jtpl
        $blockHeadJtpl.addClass('highlighted').css('display', 'block'); // Show the clicked list
    }
});

$('body').on('click', '.mobile_table_heading_wrapper-jtpl .table-li-jtpl', function() {
    var $tableHeadJtpl = $(this).parents(".mobile_table_heading_wrapper-jtpl").find(".table-head-jtpl");
    if ($tableHeadJtpl.is(":visible")) {
        $tableHeadJtpl.hide();
    } else {
        $tableHeadJtpl.show();
    }
});
$('body').on('click', '.heading-inner-table-jtpl', function() {
    var dataTarget = $(this).attr("data-index-jtpl");
    console.log(dataTarget);
    var mydata = $("#" + dataTarget).siblings();
    $(this).parents("ul.mobile_table_heading_wrapper-jtpl").html(mydata);
});


/******************* How to choose compare two end ************************/

/******************* Compare table mobile start ************************/
  $('section').click(function(e) {
    if(!$('.jtpl-main-block-head li').is(e.target)){
      $('.jtpl-main-block-head').css('display','none');
      }
    }); 
$('body').on('click', '.jtpl-main-block-head li', function(e) {
    e.preventDefault();
    var $this = $(this);
    $(this).parents(".jtpl-main-block-head").find("li").removeClass("active");
    $(this).addClass("active");  
    var html = $this.html();
    var id = $this.parents(".jtpl-block-selectors").attr("id");
    $("#" + id + " .jtpl-main-block-list").html(html);
    $("#" + id + " .jtpl-main-block-list").addClass("added-jtpl").css("background","#f0f0f0");
    var handle = $this.attr("jtpl-data-index");
    var content = $(".jtpl-mobile_table_heading_wrapper[table-title='" + handle + "']").html();
    $(".jtpl-block-selectors#" + id + " .block-body-jtpl").html(content);
    var $mainBlockHead = $(this).parents(".jtpl-block-selectors").find(".jtpl-main-block-head");
    if ($mainBlockHead.is(":visible")) {
        $mainBlockHead.hide();
    } else {
        $mainBlockHead.show();
    }
    var main_id = $this.parents(".jtpl-main-block-head").attr("id");
    $(".jtpl-main-block-head").each(function() {
        var block_d = $(this).attr("id");
        if (block_d != main_id) {
            $(this).find("li[jtpl-data-index='" + handle + "']").addClass("hidden");
        }
    });
});
// $('body').on('click', '.jtpl-main-block-list', function(e) {
//     e.preventDefault();
//     var $mainBlockHead = $(this).parents(".jtpl-block-selectors").find(".jtpl-main-block-head");
//     if ($mainBlockHead.is(":visible")) {
//         $mainBlockHead.hide();
//     } else {
//         $mainBlockHead.show();
//     }
// });
$('body').on('click', '.jtpl-main-block-list', function(e) {
    // Find the corresponding .block-head-jtpl to toggle
    var $blockHeadJtpl = $(this).closest(".jtpl-block-selectors").find(".jtpl-main-block-head");

    // If the clicked element is already highlighted, remove the class and hide it
    if ($blockHeadJtpl.hasClass('highlighted')) {
        $blockHeadJtpl.removeClass('highlighted').css('display', 'none');
    } else {
        // Otherwise, remove 'highlighted' class from all .block-head-jtpl elements
        $('.jtpl-main-block-head').removeClass('highlighted').css('display', 'none'); // Hide all other lists

        // Add the 'highlighted' class to the clicked .block-head-jtpl
        $blockHeadJtpl.addClass('highlighted').css('display', 'block'); // Show the clicked list
    }
});
$('body').on('click', '.jtpl-mobile_table_heading_wrapper .table-li-jtpl', function() {
    var $tableHeadJtpl = $(this).parents(".jtpl-mobile_table_heading_wrapper").find(".table-head-jtpl");
    if ($tableHeadJtpl.is(":visible")) {
        $tableHeadJtpl.hide();
    } else {
        $tableHeadJtpl.show();
    }
});
$('body').on('click', '.heading-inner-table-jtpl', function() {
    var dataTarget = $(this).attr("jtpl-data-index");
    console.log(dataTarget);
    var mydata = $("#" + dataTarget).siblings();
    $(this).parents("ul.jtpl-mobile_table_heading_wrapper").html(mydata);
});

/******************* Compare table mobile end ************************/

/*********** How to choose page end ************/

  
                  });